export const ACTIONS = {
   SET: 1,
   ADD_TICKET: 2,
   REMOVE_TICKET: 3,
   REMOVE_TICKETS: 4,
   ADD_TICKET_ADDONS: 5,
   REMOVE_TICKET_ADDONS: 6,
   UPDATE_TICKET: 7,
   RESET_CART: 8,
   SET_MODAL_STATUS: 9,
}



